import { defineComponent } from "vue";
import Dot from "@common/vue/Dot.vue";
import { liveStore } from "@live/store/LiveStore";
import LoadingIndicator from "@common/vue/LoadingIndicator.vue";
import { AirportApi } from "@live/api/airport/AirportApi";
export default defineComponent({
    components: {
        Dot,
        LoadingIndicator
    },
    data: function () {
        return {
            isLoading: true,
            airports: []
        };
    },
    mounted: async function () {
        const getTime = () => Math.floor(new Date().getTime());
        const server = liveStore.getters.getCurrentServerSimple;
        if (server == null) {
            return;
        }
        const t0 = getTime();
        const minDelay = 1000;
        const airports = await AirportApi.getAllAirports(server.id);
        const hasActive = (airport) => airport.hasGround || airport.hasTower || airport.hasDeparture || airport.hasApproach || airport.hasAtis;
        const sortDescInbounds = (a, b) => b.arrivalsCount - a.arrivalsCount;
        const activeSortAirports = airports.filter(hasActive).sort(sortDescInbounds);
        const inactiveSortAirports = airports.filter((airport) => !hasActive(airport)).sort(sortDescInbounds);
        const sortedAirports = activeSortAirports.concat(inactiveSortAirports);
        const set = () => {
            this.airports = sortedAirports;
            this.isLoading = false;
        };
        const deltaT = getTime() - t0;
        if (deltaT > minDelay) {
            set();
        }
        else {
            setTimeout(set, minDelay - deltaT);
        }
    }
});
